import store from "@/store/store";
import Swal from "sweetalert2";

const requireableFields = [
    "Motorista", "Ano", "Local Atendimento",
    "Chassi", "Pertences Retirados", "Km Odometro", "Nivel Combustivel",
    "AssinaturaClienteRG", "AssinaturaClienteNome", "AssinaturaClienteTelefone",
    "Pneus", "Bateria", "Nivel do GNV", "CRLV", "Situação do Veículo", "Situação Local de Atendimento"
];

class SaveStage {
    data(event) {
        if (event) {
            event.preventDefault();
        }
        store.commit("setData", store.state.inspectionData.data);

        const operationParams = store.state.inspectionData.operation.parametros;
        const clientDataRequired = operationParams["obriga_informe_informacoes_cliente"].ativo;

        let dataComplete = true;

        let dataFields = JSON.parse(localStorage.getItem("dataFields"));
        let filledFields = store.state.inspectionData.data;
        let dataField;
        if ((clientDataRequired && (!filledFields.clientName || !filledFields.clientEmail)) || !filledFields.vehicle) {
            dataComplete = false;
        }
        for (let i = 0; i < dataFields.length; i++) {
            dataField = dataFields[i];
            // KM odometro sempre é obrigatório para não quebrar envio da vistoria para a api do vex
            if (dataField.descricao == "Km Odometro") {
                dataField.required = "True";
            }
            let filledFieldData = filledFields[dataField.descricao];
            if (dataField.ativo == "True" && dataField.required == "True") {
                if (
                    dataField.descricao != "AssinaturaClienteRG" &&
                    dataField.descricao != "AssinaturaClienteNome" &&
                    dataField.descricao != "AssinaturaClienteNome" &&
                    dataField.descricao != "AssinaturaClienteTelefone"
                ) {
                    if ((filledFieldData == null || filledFieldData === "") && requireableFields.includes(dataField.descricao) ) {
                        dataComplete = false;
                    }
                }
                if (dataField.descricao == "Pneus") {
                    Object.keys(filledFieldData).forEach(function (pneu) {
                        if (
                            !filledFieldData[pneu].Estado ||
                            !filledFieldData[pneu].Marca
                        ) {
                            dataComplete = false;
                        }
                    });
                } else if (dataField.descricao == "Bateria") {
                    if (filledFields.Bateria.estado != "Não") {
                        Object.keys(filledFieldData).forEach(function (estadoOuMarca) {
                            if (!filledFieldData[estadoOuMarca]) {
                                dataComplete = false;
                            }
                        });
                    }
                }
            }
        }
        if (dataComplete) {
            store.commit("dataDone");
        } else {
            Swal.fire({
                title: "Preencha todos os campos obrigatórios!",
                text: "Os campos obrigatórios estão sinalizados com  *",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
        }
    }

    quiz(showIncompleteAlert = true) {
        if (store.getters.quizComplete) {
            store.commit("quizDone");
        } else if(showIncompleteAlert) {
            Swal.fire({
                title: "Preencha todos os campos obrigatórios!",
                text: "Os campos obrigatórios estão sinalizados com *",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
        }
    }
}

export default SaveStage;
